import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import LoadingButton from "@material-ui/lab/LoadingButton";
import { useTranslation } from "react-i18next";
import { Delete } from "@material-ui/icons";
import vacancy from "../../routes/vacancy";

type ConfirmDialogProps = {
  description?: string;
  onClose: () => void;
  onConfirm: (
    id: number | undefined,
    type: number,
    vacancyId: number | undefined,
    modalCVAutoHCode: number | undefined
  ) => void;
  open: boolean;
  pending: boolean;
  title: string;
  id: number | undefined;
  vacancyId: number | undefined;
  modalCVAutoHCode: number | undefined;
  delIndex?: number;
};

const ModalSelectCan = ({
  description,
  onClose,
  onConfirm,
  open,
  pending,
  title,
  id,
  vacancyId,
  modalCVAutoHCode,
}: ConfirmDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      style={{
        zIndex: 999999,
      }}
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      PaperProps={{
        style: {
          overflowY: "visible",
        },
      }}
    >
      <DialogContent sx={{ textAlign: "center" }}>
        <DialogTitle id="confirm-dialog-title" sx={{ pb: 1, pt: 0 }}>
          {title}
        </DialogTitle>
        {description && (
          <DialogContentText
            style={{ textAlign: "center" }}
            id="confirm-dialog-description"
          >
            {description}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onClose}>
          {t("common.cancel")}
        </Button>
        <LoadingButton
          autoFocus
          onClick={() => onConfirm(id, 2, vacancyId, modalCVAutoHCode)}
          loading={pending}
          variant="contained"
          size="small"
        >
          Sim
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ModalSelectCan;
